
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.5 24c-.827 0-1.5-.673-1.5-1.5v-5.999c0-.827.673-1.5 1.5-1.5h.5V14c0-1.654 1.346-3 3-3s3 1.346 3 3v1.001h.5c.827 0 1.5.673 1.5 1.5V22.5c0 .827-.673 1.5-1.5 1.5h-7zm0-7.999a.5.5 0 00-.5.5V22.5a.5.5 0 00.5.5h7a.5.5 0 00.5-.5v-5.999a.5.5 0 00-.5-.5h-7zM21 15v-1c0-1.103-.897-2-2-2s-2 .897-2 2l4 1z"}}),_c('path',{attrs:{"d":"M19 21.313c-.965 0-1.75-.785-1.75-1.75s.785-1.75 1.75-1.75 1.75.785 1.75 1.75-.785 1.75-1.75 1.75zm0-2.5a.75.75 0 100 1.5.75.75 0 000-1.5zM5.5 18a.5.5 0 010-1H7c.551 0 1-.448 1-1v-1H1.5C.673 15 0 14.327 0 13.5v-12C0 .673.673 0 1.5 0h18c.827 0 1.5.673 1.5 1.5v8a.5.5 0 01-1 0v-8a.5.5 0 00-.5-.5h-18a.5.5 0 00-.5.5V11h13.5a.5.5 0 010 1H1v1.5a.5.5 0 00.5.5h11a.5.5 0 010 1H9v1c0 .357-.093.699-.268 1H12.5a.5.5 0 010 1h-7z"}})])
          )
        }
      }
    